import React from 'react'
import { Dialog } from 'primereact/dialog'
import { useEffect, useState } from 'react'
import { InputText, Btn, CustomCheckbox } from '../../../../components'

const ModalListaEnvioEmail = ({ incomeLista = null, onResponse }) => {
  // Hook
  const [lista, setLista] = useState(null)

  useEffect(() => {
    incomeLista && setLista(incomeLista)
  }, [incomeLista])

  // Render
  return (
    <Dialog
      header={lista && lista.id ? 'Editando Lista de Envio' : 'Nova Lista de Envio'}
      visible={incomeLista !== null}
      onHide={() => onResponse('CLOSE')}
    >
      <div className="p-row">
        <div className="p-col-12">
          <InputText
            marginTop={0}
            label="Lista de Envio de Email"
            value={lista ? lista.nome : ''}
            onChange={value => setLista({ ...lista, nome: value })}
          />
        </div>
        <div className="p-col-12">
          <CustomCheckbox
            onChange={value => setLista({ ...lista, ativo: value })}
            checked={lista ? lista.ativo : false}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn onClick={() => onResponse('SALVAR', { ...lista })}>Salvar</Btn>
        </div>
      </div>
    </Dialog>
  )
}

export default ModalListaEnvioEmail
